
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from 'react';
import MainButton from "../../../../common/MainButton";
const Banner = ({ t }) => {
    const banner = t('coldware_mint:banner', {}, { returnObjects: true });
    const [tokenData, setTokenData] = useState({
        name: "",
        symbol: "",
        supply: ""
    });
    return (<section className={'banner'}>
            <div className="container">
                <div className="banner_wrapper">
                    <div className={'banner_title'}>
                        <span className={'banner_title_label'}>{banner.label}</span>
                        <h1 className={'banner_title_title'}>
                            <span>{banner.title_1}</span>
                            <span>{banner.title_2}</span>
                            <span>{banner.title_3}</span>
                        </h1>
                        <p className={'banner_title_description'}>{banner.description}</p>
                        <a href={process.env.NEXT_PUBLIC_APP_URL} rel={'noreferrer noopener'} className={'banner_title_cta'}>
                            <MainButton title={banner.cta}/>
                        </a>
                    </div>
                    <div className={'banner_media'}>
                        <div className="mint_form">
                            <h3 className={'mint_form_title'}>{banner.form.title}</h3>
                            <p className={'mint_form_description'}>{banner.form.description}</p>
                            <div className={'mint_form_input'}>
                                <label>
                                    <span>{banner.form.input_name}</span>
                                    <span>{tokenData.name.length}/20</span>
                                </label>
                                <input onChange={e => {
            if (e.target.value.length > 20) {
                return;
            }
            setTokenData({ ...tokenData, name: e.target.value });
        }} value={tokenData.name} placeholder={'e. g. Bitcoin, Ethereum...'}/>
                            </div>
                            <div className={'mint_form_input'}>
                                <label>
                                    <span>{banner.form.input_symbol}</span>
                                    <span>{tokenData.symbol.length}/10</span>
                                </label>
                                <input onChange={e => {
            if (e.target.value.length > 10) {
                return;
            }
            setTokenData({ ...tokenData, symbol: e.target.value });
        }} value={tokenData.symbol} placeholder={'e. g. BTC, ETH'}/>
                            </div>
                            <div className={'mint_form_input max'}>
                                <label>
                                    <span>{banner.form.input_max}</span>
                                    <span />
                                </label>
                                <input value={tokenData.supply} onChange={e => {
            setTokenData({ ...tokenData, supply: e.target.value });
            if (e.target.value > 1000000) {
                setTokenData({ ...tokenData, supply: "1000000" });
            }
        }} type={'number'} placeholder={'Maximum 1 000 000'} max={'1000000'}/>
                                <span onClick={() => {
            setTokenData({ ...tokenData, supply: "1000000" });
        }} className={'max_cta'}>MAX</span>
                            </div>
                            <button disabled={!tokenData.name || !tokenData.symbol || !+tokenData.supply} className={'mint_form_cta'}>{banner.form.cta}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__1973b7669c6__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/mint/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1973b7669c6__ as getStaticProps }
  